export default __webpack_public_path__ + "static/home-page-career-humanities-704e703c2b44e4b01ed6070dc119b8a0.png";